import React, { useEffect } from "react";
import { injectIntl } from "react-intl";
import ApplicationsCalendar from "./ApplicationsCalendar";
import ApplicationsCalendarDay from "./ApplicationsCalendarDay";
import ApplicationsList from "./ApplicationsList";

export const initialStateTabs = {
  tab: 0,
  menuList: [],
  calendarDayTitle: "",
};

function ApplicationsPage({ tabState, setTabState, intl, ...props }) {
  useEffect(() => {
    setTabState({ ...tabState, tab: 1 });
    return () => {
      setTabState({ ...tabState, tab: 0 });
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const renderComponent = (tab) => {
    switch (tab) {
      case 1:
        return (
          <ApplicationsList
            intl={intl}
            tabState={tabState}
            setTabState={setTabState}
            {...props}
          />
        );
      case 2:
        return (
          <ApplicationsCalendar
            intl={intl}
            tabState={tabState}
            setTabState={setTabState}
            {...props}
          />
        );
      case 3:
        return (
          <ApplicationsCalendarDay
            intl={intl}
            tabState={tabState}
            setTabState={setTabState}
            {...props}
          />
        );
      default:
        return null;
    }
  };

  return renderComponent(tabState.tab);
}

export default injectIntl(ApplicationsPage);
